module.exports = __webpack_public_path__ + "img/DE00930.b587b9ad.png";